export const Logo = ({ className = "", compact = false }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <img
      src="/img/emblem.webp"
      alt=""
      width="120"
      height="60"
      className="logo-blend h-8 w-auto sm:h-9"
    />
    {!compact && (
      <img
        src="/img/wordmark.webp"
        alt="WebStation"
        width="180"
        height="17"
        className="logo-blend h-[13px] w-auto sm:h-[15px]"
      />
    )}
  </span>
);
